module.exports = __webpack_public_path__ + "img/1432821976.03ff5a3a.jpg";